// Extension of siema for this project

Siema.prototype.updatePagination = function () {
    for (var i = 0; i < this.selector.closest('.siema-carousel').querySelectorAll('.siema-pagination button').length; i++) {
        // if current dot matches currentSlide prop, add a class to it, remove otherwise
        var addOrRemove = this.currentSlide === i ? 'add' : 'remove';
        this.selector.closest('.siema-carousel').querySelectorAll('.siema-pagination button')[i].classList[addOrRemove]('is-active');
    }
};

Siema.prototype.setAutoHeight = function (that) {

    var timeout;

    function autoHeight() {
        if ( that !== undefined ) {
            var currentItems, min, max, itemHeightList, height, maxHeight, i;

            min = that.currentSlide;
            max = min + that.perPage;
            itemHeightList = [];

            for (i = min; i < max; i++) {
                if ( that.innerElements[i] !== undefined ) {
                    height = parseInt(that.innerElements[i].scrollHeight, 10);                
                }
                itemHeightList.push(height);
            }
            maxHeight = Math.max.apply(null, itemHeightList);

            that.sliderFrame.style.maxHeight = maxHeight + 'px';
        }
    }

    window.addEventListener('resize', function () {
        if ( that !== undefined ) {
            that.sliderFrame.style.maxHeight = '';
        }
        clearTimeout(timeout);
        timeout = setTimeout(autoHeight, 500);
    });
    autoHeight();
};
//Siema.prototype.sameHeight = function () {
//    var _this = this;
//    console.log(this);
//};

Siema.prototype.addPagination = function () {
    var _this = this;

    var siemaPagination = document.createElement('div');
    siemaPagination.className = "siema-pagination";

    var _loop = function _loop(i) {
        var btn = document.createElement('button');
        btn.textContent = i + 1;
        btn.addEventListener('click', function () {
            return _this.goTo(i);
        });
        siemaPagination.appendChild(btn);
    };

    for (var i = 0; i < this.innerElements.length; i++) {
        _loop(i);
    }

    this.selector.closest('.siema-carousel').appendChild(siemaPagination);
};

Siema.prototype.destroyPagination = function () {
    var siemaContainer = this.selector.closest('.siema-carousel');
    var paginationToRemove = siemaContainer.querySelectorAll('.siema-pagination')[0];
    siemaContainer.removeChild(paginationToRemove);
};

Siema.prototype.updateThumbnail = function () {
    for (var i = 0; i < this.selector.closest('.siema-carousel').querySelectorAll('.siema-thumbnail button').length; i++) {

        var currentSlide = this.config.loop ? Math.round(this.currentSlide + this.perPage) : Math.round(this.currentSlide);
        var addOrRemove = currentSlide === i ? 'add' : 'remove';
        this.selector.closest('.siema-carousel').querySelectorAll('.siema-thumbnail button')[i].classList[addOrRemove]('is-active');
    }
};

Siema.prototype.addThumbnail = function () {
    var _this = this;
    var slideImages = _this.innerElements;

    var siemaThumbnail = document.createElement('div');
    siemaThumbnail.className = "siema-thumbnail";

    var _loop = function _loop(i) {
        let slide = slideImages[i];
        let imgSrc;

        if (slide.nodeName == "IMG") {
            imgSrc = slide.getAttribute("src");
        } else {
            imgSrc = slide.querySelector('img').getAttribute("src");
        }

        let siemaThumbnailCta = document.createElement("button");
        //siemaThumbnail.classList.add("is-justify-between");
        siemaThumbnailCta.classList.add("has-p-0", "has-m-2");
        siemaThumbnailCta.setAttribute('aria-label', 'Image ' + (i + 1))
        let siemaThumbnailImg = `<img class="img-fluid" src="${imgSrc}" alt=""/>`;

        siemaThumbnailCta.insertAdjacentHTML('beforeend', siemaThumbnailImg);

        siemaThumbnailCta.addEventListener('click', function () {
            return _this.goTo(i);
            
        });

        siemaThumbnail.appendChild(siemaThumbnailCta);

    } //end loop

    for (var i = 0; i < slideImages.length; i++) {
        _loop(i);
    }

    _this.selector.closest('.siema-carousel').appendChild(siemaThumbnail);

};

Siema.prototype.destroyThumbnail = function () {
    var siemaContainer = this.selector.closest('.siema-carousel');
    var paginationToRemove = siemaContainer.querySelectorAll('.siema-pagination')[0];
    siemaContainer.removeChild(paginationToRemove);
};

Siema.prototype.addArrows = function () {
    var _this = this;

    var nextArrowCopy = '<i class="rethink-icon rethink-icon-angle-right"></i><span class="screen-reader-only"> next slide</span>';
    var prevArrowCopy = '<i class="rethink-icon rethink-icon-angle-left"></i><span class="screen-reader-only"> previous slide</span>';

    var siemaArrows = document.createElement('div');
    siemaArrows.className = "siema-arrows";

    this.prevArrow = document.createElement('button');
    this.nextArrow = document.createElement('button');
    this.prevArrow.innerHTML = prevArrowCopy;
    this.nextArrow.innerHTML = nextArrowCopy;
    siemaArrows.appendChild(this.prevArrow);
    siemaArrows.appendChild(this.nextArrow);
    this.selector.closest('.siema-carousel').insertBefore(siemaArrows, null);

    this.prevArrow.addEventListener('click', function () {
        return _this.prev();
    });
    this.nextArrow.addEventListener('click', function () {
        return _this.next();
    });
};

Siema.prototype.destroyArrows = function () {
    var siemaContainer = this.selector.closest('.siema-carousel');
    var arrowsToRemove = siemaContainer.querySelectorAll('.siema-arrows')[0];
    if (arrowsToRemove) {
        siemaContainer.removeChild(arrowsToRemove);
    }
};

Siema.prototype.updateArrows = function () {
    var siemaContainer = this.selector.closest('.siema-carousel');
    var siemaArrows = siemaContainer.querySelector('.siema-arrows');
    var prevArrow = siemaArrows.firstChild;
    var nextArrow = siemaArrows.lastChild;

    if (this.currentSlide === 0) {
        prevArrow.classList.remove("is-showing");
        nextArrow.classList.add("is-showing");
    } else if (this.currentSlide === this.innerElements.length - this.perPage) {
        nextArrow.classList.remove("is-showing");
        prevArrow.classList.add("is-showing");
    } else {
        prevArrow.classList.add("is-showing");
        nextArrow.classList.add("is-showing");
    }
};

Siema.prototype.showArrows = function () {
    var siemaContainer = this.selector.closest('.siema-carousel');
    var siemaArrows = siemaContainer.querySelector('.siema-arrows');
    var prevArrow = siemaArrows.firstChild;
    var nextArrow = siemaArrows.lastChild;

    prevArrow.classList.add("is-showing");
    nextArrow.classList.add("is-showing");
};

Siema.prototype.printCurrentSlide = function () {
    var _this = this;
    var containerSiema = _this.selector.closest('.siema-carousel');

    var siemaSlides = containerSiema.querySelectorAll('.slides > div > *');
    var currentSlide = this.config.loop ? Math.round(this.currentSlide + this.perPage) : Math.round(this.currentSlide);

    for (var i = 0; i < siemaSlides.length; i++) {
        siemaSlides[i].tabIndex = 0;
        siemaSlides[i].classList.add('slide');

        siemaSlides[i].addEventListener('focus', function () {
            return _this.goTo(i);
        });

        if (i === currentSlide) {
            siemaSlides[i].classList.add('has-active-slide');
            siemaSlides[i].inert = false;
        } else {
            siemaSlides[i].classList.remove('has-active-slide');
            siemaSlides[i].inert = true;
        }
    }
};
